import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { UserListActionsColumn } from '@app/feature/user/user-list/user-list-actions.column';

import { CustomerUserListEmailAddressColumn } from './customer-user-list-email-address.column';
import { CustomerUserListFirstNameColumn } from './customer-user-list-first-name.column';
import { CustomerUserListLastNameColumn } from './customer-user-list-last-name.column';
import { CustomerUserListMobileNumberColumn } from './customer-user-list-mobile-number.column';
import { CustomerUserListRolesColumn } from './customer-user-list-roles.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const customerUserListColumnHelper =
  createColumnHelper<GatewayUserModel>();

type ResourceColumnType = ColumnDef<GatewayUserModel, any>[];

export const CUSTOMER_USER_LIST_COLUMN_LIST: ResourceColumnType = [
  customerUserListColumnHelper.accessor(
    'firstName',
    CustomerUserListFirstNameColumn,
  ),
  customerUserListColumnHelper.accessor(
    'lastName',
    CustomerUserListLastNameColumn,
  ),
  customerUserListColumnHelper.accessor(
    'mobileNumber',
    CustomerUserListMobileNumberColumn,
  ),
  customerUserListColumnHelper.accessor(
    'emailAddress',
    CustomerUserListEmailAddressColumn,
  ),
  customerUserListColumnHelper.accessor('roles', CustomerUserListRolesColumn),
  customerUserListColumnHelper.display(UserListActionsColumn),
];

export const CUSTOMER_USER_LIST_COLUMN_ID_LIST =
  CUSTOMER_USER_LIST_COLUMN_LIST.flatMap((columnDef) => {
    if ('accessorKey' in columnDef) {
      return [columnDef.id ?? (columnDef.accessorKey as string)];
    }

    if (columnDef.id) {
      return [columnDef.id];
    }

    return [];
  });

export const CUSTOMER_USER_LIST_COLUMN_ORDER = [
  ...CUSTOMER_USER_LIST_COLUMN_ID_LIST,
];

export const CUSTOMER_USER_LIST_COLUMN_VISIBILITY =
  CUSTOMER_USER_LIST_COLUMN_ID_LIST.reduce((columnVisibility, columnId) => {
    return { ...columnVisibility, [columnId]: true };
  }, {});
